export const DATE_FIELDS = [
  "createdAt",
  "updatedAt",
  "date",
  "timestamp",
  "expiresAt",
  "expiryAt",
  "activeFrom",
  "activeTo",
  "lastLoginAt",
  "suspendedAt",
  "datePaid",
  "dateCompleted",
  "issueDate",
  "dueDate",
  "assignedDate",
  "verifiedAt",
  "acceptedAt",
  "archivedAt",
  "lockedAt",
  "releaseDate",
  "preOrderDeadline",
  "estimatedArrivalDate",
  "shippedAt",
  "readDate",
  "expiryDate",
  "uploadedAt",
  "processedAt",
  "requestedAt",
  "dateBalancePaid",
  "joinDate",
  "resetTime",
  "paidAt",
  "reportedAt",
  "settledAt",
  "assignedAt",
  "deliveryDate",
  "docDate",
  "endDate",
  "fromDate",
  "joinedDate",
  "orderDate",
  "removedDate",
  "shipmentDate",
  "startDate",
  "txDate",
];

export const toDate = (val) => {
  if (!val) return null;

  if (val && typeof val === "object") {
    if (val._seconds !== undefined) return new Date(val._seconds * 1000);
    if (val.seconds !== undefined) return new Date(val.seconds * 1000);
    if (typeof val.toDate === "function") return val.toDate();
  }

  const date = new Date(val);
  return isNaN(date.getTime()) ? null : date;
};

export const formatTimestamps = (data) => {
  if (!data) return data;

  if (Array.isArray(data)) {
    return data.map((item) => formatTimestamps(item));
  }

  if (typeof data === "object" && data !== null) {
    if (
      data._seconds !== undefined ||
      data.seconds !== undefined ||
      typeof data.toDate === "function" ||
      data instanceof Date
    ) {
      const date = toDate(data);
      return date ? date.toISOString() : data;
    }

    if (
      (typeof File !== "undefined" && data instanceof File) ||
      (typeof Blob !== "undefined" && data instanceof Blob) ||
      (typeof FormData !== "undefined" && data instanceof FormData)
    ) {
      return data;
    }

    const result = Array.isArray(data) ? [] : {};
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const value = data[key];
        if (DATE_FIELDS.includes(key) && value) {
          const date = toDate(value);
          result[key] = date ? date.toISOString() : value;
        } else if (typeof value === "object" && value !== null) {
          result[key] = formatTimestamps(value);
        } else {
          result[key] = value;
        }
      }
    }
    return result;
  }

  return data;
};

export const formatReadableDate = (val) => {
  const date = toDate(val);
  if (!date) return "—";

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatFirebaseDate = (val) => {
  const date = toDate(val);
  if (!date) return "N/A";
  return date.toLocaleDateString();
};

export const formatDateForInput = (val) => {
  const date = toDate(val);
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
